// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".receipt-list .coupon-row{color:red}", "",{"version":3,"sources":["webpack://./pos/app/scripts/components/receipt-list/receipt-list.scss"],"names":[],"mappings":"AACE,0BACE,SAAA","sourcesContent":[".receipt-list {\n  .coupon-row {\n    color: red;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
